/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SestData = {
  /**
   * * 소모품 코드
   */
  sestCode: string;
  /**
   * * 소모품 명
   */
  sestName: string;
  /**
   * 최근 교환 일시
   */
  replaceDate: string;
  /**
   * 최근 교환 시점 누적주행
   */
  replaceOdometer: number;
  /**
   * 해당 데이터의 업데이터 날짜
   */
  updateDate: string;
  /**
   * 최근 교환 정보의 출처 (0: HSW, 1: 사용자 입력)
   */
  sourceType: SestData.sourceType;
};
export namespace SestData {
  /**
   * 최근 교환 정보의 출처 (0: HSW, 1: 사용자 입력)
   */
  export enum sourceType {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    DEFAULT = 'DEFAULT',
    PREDICTION = 'PREDICTION',
    ADMIN = 'ADMIN',
  }
}

